import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_ESUS,
    useChartsData
} from '../../../Common/Filters/useChartsData';

export const VaccinationChartsDataContext = createContext();

const VaccinationChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.PRODUCTION_VACCINATION,
            url: 'governanceroom/esus/production/vaccination'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            location: filters.unidade.value,
            immunobiologicals: filters.immunobiological.map(
                (immunobiological) => immunobiological.value
            ),
            immunobiologicals_doses: filters.immunobiological_dose.map(
                (immunobiologicalDose) => immunobiologicalDose.value
            ),
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );


    const chartData = data
        ? {
              indicators: {
                  totalVaccination: data?.indicators?.totalVaccination ?? 0,
                  vaccinatedKidsUnderOneYearWithPenta:
                      data?.indicators?.vaccinatedKidsUnderOneYearWithPenta ??
                      0,
                  vaccinatedKidsUnderOneYearWithHB:
                      data?.indicators?.vaccinatedKidsUnderOneYearWithHB ?? 0,
                  vaccinatedKidsUnderOneYearWithVIP:
                      data?.indicators?.vaccinatedKidsUnderOneYearWithVIP ?? 0
              },
              totalVaccinationByAge: data?.totalVaccinationByAge ?? [],
              totalVaccinationByImmunoBiological:
                  data?.totalVaccinationByImmunoBiological ?? [],
              totalVaccinationByStrategy:
                  data?.totalVaccinationByStrategy ?? [],
              totalVaccinationByYear: data?.totalVaccinationByYear ?? [],
              totalVaccinationByMonth: data?.totalVaccinationByMonth ?? []
          }
        : {
              indicators: {
                  totalVaccination: 0,
                  vaccinatedKidsUnderOneYearWithPenta: 0,
                  vaccinatedKidsUnderOneYearWithHB: 0,
                  vaccinatedKidsUnderOneYearWithVIP: 0
              },
              totalVaccinationByAge: [],
              totalVaccinationByImmunoBiological: [],
              totalVaccinationByStrategy: [],
              totalVaccinationByYear: [],
              totalVaccinationByMonth: []
          };

    return (
        <VaccinationChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </VaccinationChartsDataContext.Provider>
    );
};

export default VaccinationChartsDataProvider;
